import { useEffect, useState } from "react"
import {
  ref,
  query,
  orderByChild,
  startAt,
  onValue,
  remove,
} from "firebase/database"
import { db, rtdb } from "../../Firebase/config"
import Notify from "../Componentslogic/Usenotifications"
import {
  collection,
  getDocs,
  query as firestoreQuery,
  where,
  updateDoc,
  doc,
} from "firebase/firestore"

const UsefetchcollectionTime = (collectionName) => {
  const [data, setData] = useState([]) // Holds fetched data
  const [loading, setLoading] = useState(false) // Loading state
  const [hasMore, setHasMore] = useState(true) // Tracks if more data is available
  let unsubscribe = null

  // Fetch orders from the last 15 hours
  const getCollection = () => {
    setLoading(true)

    try {
      const ordersRef = ref(rtdb, collectionName)
      let ordersQuery = query(ordersRef, orderByChild("createdAt"))

      // Subscribe to real-time updates
      unsubscribe = onValue(ordersQuery, (snapshot) => {
        if (snapshot.exists()) {
          const fetchedData = Object.entries(snapshot.val()).map(
            ([id, order]) => ({
              id,
              ...order,
              createdAt: new Date(order.createdAt), // Convert to Date object for sorting
            })
          )

          // Sort orders by createdAt (latest first)
          fetchedData.sort((a, b) => b.createdAt - a.createdAt)

          setData(fetchedData)
        } else {
          setData([]) // No more data available
        }

        setLoading(false)
      })
    } catch (error) {
      console.error("Error fetching orders: ", error)
      setLoading(false)
    }
  }

  // Load more orders when paginating
  const loadMore = () => {
    if (hasMore) {
      getCollection()
    }
  }

  // Enable real-time sync only when app is in foreground
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        getCollection() // Fetch & enable real-time sync when the app is active
      } else if (unsubscribe) {
        unsubscribe() // Disable sync when app is inactive
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange)
    getCollection() // Initial fetch

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange)
      if (unsubscribe) unsubscribe() // Cleanup on unmount
    }
  }, [collectionName])

  // 🔥 Reset only orders that are marked as `Paid`
  const resetPaidOrders = async () => {
    try {
      // 🔥 Step 1: Fetch Undelivered Orders from Firestore
      const ordersRef = collection(db, "Orders")
      const q = firestoreQuery(ordersRef, where("Checked", "==", false))
      const querySnapshot = await getDocs(q)

      let batchUpdates = []

      if (!querySnapshot.empty) {
        querySnapshot.forEach((docSnap) => {
          const orderRef = doc(db, "Orders", docSnap.id)
          batchUpdates.push(
            updateDoc(orderRef, { Confirmed: true, reviewpass: true })
          ) // Mark as delivered
        })

        // 🔥 Step 2: Execute Updates in Firestore
        await Promise.all(batchUpdates)
      }

      // 🔥 Step 3: Delete All Orders from RTDB
      const ordersRTDBRef = ref(rtdb, "orders")
      await remove(ordersRTDBRef)

      // 🔥 Step 4: Clear UI State and Notify User
      Notify("All orders reset successfully.", "success")
    } catch (error) {
      console.error("Error resetting orders:", error)
      Notify("Failed to reset orders. Try again.", "error")
    }
  }

  // 🔥 Reset only orders that are marked as `Paid`
  const resetdeliveredOrders = async () => {
    try {
      // 🔥 Step 1: Fetch Undelivered Orders from Firestore
      const ordersRef = collection(db, "DeliveryOrders")
      const q = firestoreQuery(ordersRef, where("delivered", "==", false))
      const querySnapshot = await getDocs(q)

      let batchUpdates = []

      if (!querySnapshot.empty) {
        for (const docSnap of querySnapshot.docs) {
          const orderData = docSnap.data()
          const orderRef = doc(db, "DeliveryOrders", docSnap.id)

          batchUpdates.push(
            updateDoc(orderRef, { delivered: true, reviewpass: true })
          )
        }

        // 🔥 Execute Updates in Firestore
        await Promise.all(batchUpdates)
      }

      // 🔥 Step 6: Delete All Orders from RTDB
      const ordersRTDBRef = ref(rtdb, "DeliveryOrders")
      await remove(ordersRTDBRef)

      // 🔥 Step 7: Clear UI State and Notify User
      Notify(
        "All orders reset successfully. Coins have been rewarded!",
        "success"
      )
    } catch (error) {
      console.error("Error resetting orders:", error)
      Notify("Failed to reset orders. Try again.", "error")
    }
  }

  return {
    data,
    loadMore,
    loading,
    hasMore,
    resetPaidOrders,
    resetdeliveredOrders,
  }
}

export default UsefetchcollectionTime
